import { withInstall } from '../../utils/install';
import Badge from './index.vue';

export const IvueBadge = withInstall(Badge);
export default IvueBadge;

export * from './index.vue';
